import { createDefaultMutationHook, createBulkMutationHook } from "hooks/useMutationHandler";

import { STAR_MODULE } from "./gql";

const useSetModuleFavorite = createDefaultMutationHook(STAR_MODULE);
export const useBulkSetModuleFavorite = createBulkMutationHook(STAR_MODULE);

export default useSetModuleFavorite;
